import AbstractComponent from "./abstract-component";

export default class SiteLoader extends AbstractComponent {
    constructor(el) {
        super(el);
        this.logo = this.$el.querySelector('.c-site-logo');
        this.timeline = null;
        this.startTime = Date.now();
        this._exiting = false;
        this._finished = false;
        this._doneDispatched = false;
        this.init();
    }

    init() {
        if (!document.body.hasAttribute('data-loader-show')) {
            this.finishImmediately();
            return;
        }

        const isShortVisit = this.isInternalNavigation();
        const minDuration = isShortVisit ? 500 : 1400;
        const maxDuration = 2500;

        if (this.logo) {
            this.app.gsap.set(this.logo, { autoAlpha: 0, y: 15 });
            this.app.gsap.to(this.logo, {
                autoAlpha: 1,
                y: 0,
                duration: 0.45,
                delay: 0.15,
                ease: 'power2.out',
            });
        }

        Promise.race([
            this.waitForPageReady(),
            new Promise((resolve) => setTimeout(resolve, maxDuration)),
        ]).then(() => {
            const elapsed = Date.now() - this.startTime;
            const remaining = Math.max(0, minDuration - elapsed);
            setTimeout(() => this.playExit(), remaining);
        });
    }

    isInternalNavigation() {
        const referrer = document.referrer;

        if (!referrer) {
            return false;
        }

        try {
            const currentDomain = window.location.hostname;
            const referrerDomain = new URL(referrer).hostname;
            return referrerDomain === currentDomain;
        } catch {
            return false;
        }
    }

    waitForPageReady() {
        const promises = [];

        if (document.readyState === 'complete') {
            promises.push(Promise.resolve());
        } else {
            promises.push(new Promise((resolve) => {
                window.addEventListener('load', resolve, { once: true });
            }));
        }

        if (document.fonts && document.fonts.ready) {
            promises.push(document.fonts.ready.catch(() => {}));
        }

        return Promise.all(promises);
    }

    playExit() {
        if (this._exiting || this._finished) return;
        this._exiting = true;

        if (this.timeline) {
            this.timeline.kill();
        }

        this.$el.classList.add('is-exiting');
        this.dispatchDone();

        this.timeline = this.app.gsap.timeline({
            onComplete: () => this.finish(),
        });

        this.timeline.to(this.$el, {
            yPercent: -100,
            duration: 0.7,
            ease: 'power3.inOut',
        });
    }

    dispatchDone() {
        if (this._doneDispatched) return;
        this._doneDispatched = true;
        window.dispatchEvent(new CustomEvent('site-loader:done'));
    }

    finish() {
        if (this._finished) return;
        this._finished = true;

        document.body.removeAttribute('data-loader-show');
        this.$el.classList.remove('is-exiting');
        this.$el.classList.add('is-done');
    }

    finishImmediately() {
        if (this._finished) return;
        this._finished = true;

        document.body.removeAttribute('data-loader-show');
        this.$el.classList.add('is-done');
        this.dispatchDone();
    }

    destroy() {
        this.timeline?.kill();
        this.timeline = null;
    }
}
